// Tracks per-tab-session start time and per-day action counts, purely to
// supply real (not fabricated) values for pad_engagement_activity properties.
const SESSION_START_KEY = "cta_pad_session_start";
// All daily counts live under one key, keyed by activityType, and are reset
// whenever the stored date isn't today - so this never accumulates a new
// localStorage key per day like a per-date-suffixed key would.
const DAILY_COUNTS_KEY = "cta_pad_daily_counts";

function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

export function getSessionDurationSeconds() {
  try {
    let start = window.sessionStorage.getItem(SESSION_START_KEY);
    if (!start) {
      start = String(Date.now());
      window.sessionStorage.setItem(SESSION_START_KEY, start);
    }
    return Math.round((Date.now() - Number(start)) / 1000);
  } catch {
    return undefined;
  }
}

export function incrementAndGetDailyActionCount(activityType) {
  try {
    const today = todayKey();
    let stored;
    try {
      stored = JSON.parse(window.localStorage.getItem(DAILY_COUNTS_KEY) || "null");
    } catch {
      stored = null;
    }

    // Drop yesterday's (or any stale) counts entirely once the date rolls
    // over, rather than letting them pile up under separate keys.
    const counts = stored && stored.date === today ? stored.counts : {};
    const next = (counts[activityType] || 0) + 1;
    counts[activityType] = next;

    window.localStorage.setItem(DAILY_COUNTS_KEY, JSON.stringify({ date: today, counts }));
    return next;
  } catch {
    return undefined;
  }
}
